import { dao } from '@platform/dao';
import type { IRecord } from '@platform/core/types';
import type { ICodeArg } from './args/ICodeArg';
import { baseApi, listTag, run } from './baseApi';

/**
 * Запис за кодом («TSK-3» → тип task, номер 3) для пошуку (patterns/search: збіг за кодом, як його показано): список типу з фільтром
 * code:eq:N; не знайдено або тип недоступний — null (пошук показує решту збігів).
 */
export const recordByCodeApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    recordByCode: b.query<IRecord | null, ICodeArg>({
      queryFn: ({ ws, rt, code }) => run(async () => {
        try {
          return (await dao.records.list(ws, rt, { filter: `code:eq:${code}`, pageSize: 10, facets: false })).items[0] ?? null;
        } catch {
          return null;
        }
      }),
      providesTags: (_r, _e, { rt }) => [listTag(rt)],
    }),
  }),
});

export const { useRecordByCodeQuery } = recordByCodeApi;
